<p-dialog
  [closable]="true"
  [(visible)]="displayModal"
  [modal]="false"
  class="modelstackerpopup"
  [ngClass]="{
    modelstackerpopupwithouttag: !showHeader,
    modelstackerpopupwithtag: showHeader,
    'rem-stacker': instanceNumber > 1,
  }"
  [draggable]="false"
  [resizable]="false"
  [focusTrap]="false"
  [minX]="500"
  [keepInViewport]="true"
  [position]="'right'"
  (onHide)="closeDialog()">
  <!-- <ng-template pTemplate="header">
  <div class="w-100 has-border">
    <ng-content select=".panelHeading"></ng-content>
  </div>
</ng-template>
<div class="dialog-section mb-4">
  <ng-content select=".panelBody"></ng-content>
</div> -->
  <ng-template #headless>
    <ng-content select=".panelBody"></ng-content>
  </ng-template>
</p-dialog>
